import { Card, CardContent } from "@/components/ui/card";

const Chip = ({ children, tone = "slate", testid }) => {
  const tones = {
    slate: "bg-slate-800/80 border-slate-700 text-slate-200",
    amber: "bg-amber-500/15 border-amber-500/60 text-amber-300 shadow-[0_0_14px_rgba(245,158,11,0.25)]",
    emerald: "bg-emerald-500/15 border-emerald-500/50 text-emerald-300",
    cyan: "bg-cyan-500/10 border-cyan-500/50 text-cyan-300",
  };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center justify-center min-w-[44px] h-11 px-3 rounded-lg border font-mono-digit text-xl font-bold ${tones[tone]}`}
    >
      {children}
    </span>
  );
};

export const DateSumPanel = ({ breakdown }) => {
  const { month, day, monthOnes, dayTens, dayOnes, rawSum, sumDigit } = breakdown;
  return (
    <Card className="bg-[#131c2e]/90 border-slate-800 shadow-xl shadow-black/40">
      <CardContent className="p-5 sm:p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg sm:text-xl font-bold text-slate-100">
            Step 2 · Date Sum
          </h3>
          <span className="text-[11px] uppercase tracking-widest text-slate-500 font-heading">
            Ones-of-month + Ones-of-day → reduce
          </span>
        </div>

        <div className="flex flex-wrap items-center gap-2 sm:gap-3" data-testid="date-sum-math">
          <div className="flex flex-col items-center gap-1">
            <span className="text-[10px] uppercase text-slate-500">Month</span>
            <div className="flex gap-1">
              <Chip tone="slate">{Math.floor(month / 10)}</Chip>
              <Chip tone="amber" testid="date-sum-month-ones">{monthOnes}</Chip>
            </div>
          </div>
          <span className="text-slate-500 text-2xl font-mono-digit">+</span>
          <div className="flex flex-col items-center gap-1">
            <span className="text-[10px] uppercase text-slate-500">Day</span>
            <div className="flex gap-1">
              <Chip tone="slate">{dayTens}</Chip>
              <Chip tone="amber" testid="date-sum-day-ones">{dayOnes}</Chip>
            </div>
          </div>
          <span className="text-slate-500 text-2xl font-mono-digit">=</span>
          <div className="flex flex-col items-center gap-1">
            <span className="text-[10px] uppercase text-slate-500">Raw</span>
            <Chip tone="cyan">{rawSum}</Chip>
          </div>
          <span className="text-slate-500 text-2xl font-mono-digit">→</span>
          <div className="flex flex-col items-center gap-1">
            <span className="text-[10px] uppercase text-slate-500">Sum Digit</span>
            <Chip tone="emerald" testid="date-sum-digit">{sumDigit}</Chip>
          </div>
        </div>

        <p className="text-sm text-slate-400 leading-relaxed">
          Carrying <span className="text-emerald-300 font-mono-digit font-bold">{sumDigit}</span> into
          Step 3. Any digit in the rolling grid that matches this value is highlighted emerald.
        </p>
      </CardContent>
    </Card>
  );
};
